function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Send = function Send(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M22.93 1.293c.278.278.367.695.227 1.063L15.45 22.58c-.148.387-.52.643-.935.643h-.006a1 1 0 0 1-.932-.654l-3.206-8.716-8.717-3.207a1.001 1.001 0 0 1-.01-1.873l20.223-7.707a1 1 0 0 1 1.063.228M20.494 3.73 4.851 9.69l6.044 2.223 3.227-3.226a1 1 0 0 1 1.414 1.414l-3.227 3.226 2.223 6.044z"
  }));
};
export default Send;